import { BASE_URL } from "../utils/constants";
import handler from "../utils/handler";
import { clearAllLocalStorage } from "../utils/localStorageManager";
import Moment from "moment";

export const GetSupportTicketData = async(value) => {
    const accessToken = sessionStorage.getItem("accessToken");
    
    try {

        const headers = {
            "Content-Type": "application/json",
        }
        
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`
        }
        
        let response = await fetch(`${BASE_URL}/core/support-tickets`, {
            method: "GET",
            headers,
           
        });

        if (response.status === 401) {
            clearAllLocalStorage();
        };

        let result = handler(response)
        return result
       
    } catch (e) {
        throw e;
    }
}


export const GetRequestsCountData = async(value) => {
    const accessToken = sessionStorage.getItem("accessToken");
    
    try {

        const headers = {
            "Content-Type": "application/json",
        }
        
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`
        }

        let response = await fetch(`${BASE_URL}/core/support-tickets/requests/count`, {
            method: "GET",
            headers,
           
        });

        if (response.status === 401) {
            clearAllLocalStorage();
        };

        let result = handler(response)
        return result
       
    } catch (e) {
        throw e;
    }
}

export const UpdateSupportTicketStatus = async(encryptedId, status) => {
    const accessToken = sessionStorage.getItem("accessToken");
    
    try {
        const headers = {
            "Content-Type": "application/json",
        }
        
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`
        }
        
        let response = await fetch(`${BASE_URL}/core/support-tickets/update-status`, {
            method: "POST",
            headers,
            body: JSON.stringify({
                encryptedId: encryptedId,
                status: status,
            })
        });

        if (response.status === 401) {
            clearAllLocalStorage();
        };

        let result = handler(response)
        return result
       
    } catch (e) {
        throw e;
    }
}

export const GetSupportTicketDataPaginated = async(page = 0, size = 10, startDate = null, endDate = null, status = null) => {
    const accessToken = sessionStorage.getItem("accessToken");
    
    try {

        const headers = {
            "Content-Type": "application/json",
        }
        
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`
        }
        
        // Format dates as YYYY-MM-DD using moment
        const formattedStartDate = startDate ? Moment(startDate).format("YYYY-MM-DD") : null;
        const formattedEndDate = endDate ? Moment(endDate).format("YYYY-MM-DD") : null;
        
        // Convert page to 1-based indexing
        const adjustedPage = page + 1;
        
        let url = `${BASE_URL}/admin/support-tickets/filter?page=${adjustedPage}&size=${size}`;
        
        if (formattedStartDate) {
            url += `&startDate=${formattedStartDate}`;
        }
        if (formattedEndDate) {
            url += `&endDate=${formattedEndDate}`;
        }
        if (status && status !== "ALL") {
            url += `&status=${status}`;
        }
        
        let response = await fetch(url, {
            method: "GET",
            headers,
           
        });

        if (response.status === 401) {
            clearAllLocalStorage();
        };

        let result = handler(response)
        return result
       
    } catch (e) {
        throw e;
    }
}